import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlueDot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 5,
		cy: 5,
		r: 5,
		fill: "#5FA8FF"
	})
});
export default SvgBlueDot;
